import {useMemo} from 'react';
import {useQuery, useQueryClient} from '@tanstack/react-query';
import {fetchTiers, TIER_QUERY_KEY} from '@/services/ClubPlus/TierService';

export const useActiveTiers = () => {
  const queryClient = useQueryClient();

  const tiersQuery = useQuery({
    queryKey: [TIER_QUERY_KEY.ACTIVE_TIERS],
    queryFn: () => fetchTiers('active=true')
  });

  const tiers = useMemo(() => {
    if (!tiersQuery.data) return tiersQuery.data;
    return [...tiersQuery.data].sort((a, b) => (a.rank ?? 0) - (b.rank ?? 0));
  }, [tiersQuery.data]);

  const invalidateTiersQuery = () => {
    queryClient.invalidateQueries({queryKey: [TIER_QUERY_KEY.ACTIVE_TIERS]});
  };

  return {
    tiers,
    invalidateTiers: invalidateTiersQuery,
    isLoadingTiers: tiersQuery.isLoading,
    errorTiers: tiersQuery.error
  };
};
